module.exports = __webpack_public_path__ + "img/AnyPay-Logo.ef682974.png";